/* eslint-disable max-len */
import { useEffect } from 'react';
import { useTimestamp } from './useTimestamp';
import { isUndefined } from 'lodash';
export function useReadableEventRefresher(...props) {
    const { setCurrentTimestamp } = useTimestamp();
    useEffect(() => {
        const filteredBrokers = props.filter(prop => !isUndefined(prop));
        const unRegisters = filteredBrokers.map(prop => {
            return prop.reo(setCurrentTimestamp);
        });
        const unRegisters2 = filteredBrokers.map(prop => {
            return prop.violationsChanged.reo(setCurrentTimestamp);
        });
        // Call set current timestamp to make sure we're refreshed when `props` are changed
        setCurrentTimestamp();
        return () => {
            unRegisters.forEach(unRegister => unRegister());
            unRegisters2.forEach(unRegister => unRegister());
        };
    }, props);
    return props.map(prop => prop ? [prop.get(), prop.getViolations()] : undefined);
}
//# sourceMappingURL=useReadableEventRefresher.js.map